<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <!-- <div id="alertMessage">
            <base-alert type="default" dismissible>
                <span class="alert-inner--text"><strong>Default!</strong> This is a default alert—check it out!</span>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </base-alert>
            </div> -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                             <base-dropdown >
                                <base-button slot="title" type="success" class="dropdown-toggle">
                                  System Profiles - {{_.startCase(currentProfile)}}
                                </base-button>
                                    <a @click.prevent="setCurrentProfile('companies')" class="dropdown-item" href="#">Company</a>
                                    <a @click.prevent="setCurrentProfile('sites')" class="dropdown-item" href="#">Site</a>
                                    <a @click.prevent="setCurrentProfile('users')" class="dropdown-item" href="#">User</a>
                                    <a @click.prevent="setCurrentProfile('user_groups')" class="dropdown-item" href="#">User Groups</a>
                            </base-dropdown>
                        </div>
                        <div id="profileDiv" class="card-body">
                            <profiles-table></profiles-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
  import ProfilesTable from '../Tables/PosProfilesTable.vue' 
  import { mapState, mapActions } from 'vuex'

  export default {
      mounted: function() {
        var acceptedProfiles = ['companies', 'sites', 'users', 'user_groups']
        if(acceptedProfiles.includes(this.currentProfile)){
            this.setCurrentProfile(this.currentProfile);
        } else {
            this.setCurrentProfile("companies");
        }
      },
      computed: {
        ...mapState(['currentProfile','currentApiURL', 'endPoint']),
      },
      components:{
          ProfilesTable
      },
      methods:{
        ...mapActions(['updateCurrentProfile']),
        setCurrentProfile(profile){
            this.updateCurrentProfile(profile)
            // eslint-disable-next-line 
            //this.$children[2].$refs.vuetable.refresh()
        }
      }
  };
</script>

<style>

</style>
